import React from 'react';
import { useDispatch } from 'react-redux';
import { Link as LinkComponent } from 'react-router-dom';
import styled from 'styled-components';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Badge } from '@prisjakt/ui/badge';
import { headerClickEvent } from '../../../../actions/product';

type Props = {
  category?: { name: string | null; pathName: string };
  isExperiment: boolean;
  rank: number | null;
};

export const RankBadge = (props: Props) => {
  const { category, isExperiment, rank } = props;

  const { t } = useAppContext();

  const dispatch = useDispatch();

  const handleRankCategoryClick = () =>
    dispatch(headerClickEvent('rank-category'));

  const renderBadge = () => {
    if (!rank) return null;
    return (
      <Badge
        color={isExperiment ? 'BLUE_INVERTED' : 'GREY'}
        key="categoryRank"
        text={t('product', 'rank.position', {
          rank: <span key="rank">{rank}</span>,
        })}
      />
    );
  };

  return (
    <StyledRankBadge>
      {category
        ? t('product', 'rank.in-category', {
            categoryRank: renderBadge(),
            categoryLink: (
              <Link
                to={category.pathName}
                key="categoryLink"
                onClick={handleRankCategoryClick}
              >
                {category.name}
              </Link>
            ),
          })
        : renderBadge()}
    </StyledRankBadge>
  );
};

const StyledRankBadge = styled.div`
  color: ${p => p.theme.colors.base600};
`;

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.colors.maybeBlue700};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${p => p.theme.colors.maybeBlue500};
    text-decoration: underline;
  }
`;
